import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ActivityContentObjectDetailDataObject } from 'models/service';

export const getActivity = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.get<ActivityContentObjectDetailDataObject, ApiClientResponse<ActivityContentObjectDetailDataObject>>(
    routes.activities.get(id),
  );
